import template from './wizard_leave_setup_roles.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupRoles
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable(null);
		this.access_roles = ko.observableArray();
		this.access_roles_visible_profile = ko.observableArray();
		this.selected_balance_roles = ko.observableArray();
		this.visible_on_profile = ko.observableArray(); 
	}

	close()
	{
		this.dialog.close();
	}
}

class WizardLeaveSetupRolesPage
{
	constructor (bindings)
	{
		this.viewModel = new WizardLeaveSetupRoles(this);
		this.bindings = bindings;
	}

	async init()
	{
		console.log('bindings', this.bindings);
		const roles = await Utils.getGrapeListAccessRoles();
		this.viewModel.access_roles(roles);
		this.viewModel.access_roles_visible_profile(roles);

		//apply bindings - check leave_object first (more specific), then fallback to direct binding
		if (this.bindings.leave_object?.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_object.leave_type_id);
		else if (this.bindings.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id);

		// Handle visible_on_profile
		if (this.bindings.leave_object?.visible_on_profile)
			this.viewModel.visible_on_profile(this.bindings.leave_object.visible_on_profile);
		else if (this.bindings.visible_on_profile)
			this.viewModel.visible_on_profile(this.bindings.visible_on_profile);
		else
			this.viewModel.visible_on_profile(['admin', 'employee']);

		// Handle show_available_and_cycle_for_roles
		if (this.bindings.leave_object?.show_available_and_cycle_for_roles)
			this.viewModel.selected_balance_roles(this.bindings.leave_object.show_available_and_cycle_for_roles);
		else if (this.bindings.show_available_and_cycle_for_roles)
			this.viewModel.selected_balance_roles(this.bindings.show_available_and_cycle_for_roles);
		else
			this.viewModel.selected_balance_roles(['admin', 'employee']);
	}

	async back_wizard()
	{
		if (this.viewModel.leave_type_id())
		{
			this.viewModel.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.viewModel.leave_type_id()});
			return;
		}

		let data = Object.assign({}, this.bindings, {
			visible_on_profile: this.viewModel.visible_on_profile(),
			show_available_and_cycle_for_roles: this.viewModel.selected_balance_roles()
		});
		
		this.viewModel.close();
		await Grape.dialog.open('WizardLeaveSetupCycle', data);
	}

	async next_wizard()
	{
		let data = Object.assign({}, this.bindings, {
			visible_on_profile: this.viewModel.visible_on_profile(),
			show_available_and_cycle_for_roles: this.viewModel.selected_balance_roles()
		});
		
		await Grape.dialog.open('WizardLeaveSetupHolidays', data);
		this.viewModel.close();
	}

	async back_and_save()
	{
		// Update the leave_object with current values
		this.bindings.leave_object.show_available_and_cycle_for_roles = this.viewModel.selected_balance_roles();
		this.bindings.leave_object.visible_on_profile = this.viewModel.visible_on_profile();
		
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.bindings.leave_object);
		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.viewModel.close();
		}
	}
}

export default {
	name: 'WizardLeaveSetupRoles',
	dialog_class: WizardLeaveSetupRolesPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_roles',
	provider: 'ps'
};
